module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/post-template/post-template.component.css
// module id = ./src/app/components/post-template/post-template.component.css
// module chunks = main